import Vue from 'vue';
import * as types from './mutation-types';

// Utils
import {
  formatDataFromCompany,
  formatUsers,
  formatCurrentUser,
} from '@/utils/shizen-stats-utils';

const mutations = {
  /** If datas is fetching set as true also set as false */
  [types.GET_SHIZEN_STATS_LOADING](state, payload) {
    const isLoading = payload.loading === true;
    Vue.set(state, 'statsLoading', isLoading);
  },

  /** Put datas in the state as an object properties */
  [types.GET_SHIZEN_STATS](state, payload) {
    const { formattedStats } = payload;
    if (formattedStats && formattedStats.companies) {
      Object.freeze(formattedStats);
      Vue.set(state, 'stats', formattedStats);
    }
  },

  /** Format data you need at the moment */
  [types.FORMAT_SHIZEN_STATS]({ stats }, { dataType, ids }) {
    if (dataType === 'allDatas') return;
    const currentCompany = stats.companies.find(company => Number(company.id) === Number(ids.companyId));
    const currentCompanyIndex = stats.companies.findIndex(company => Number(company.id) === Number(ids.companyId));
    if (dataType === 'companies') {
      Vue.set(
        stats.companies[currentCompanyIndex],
        'teams',
        formatDataFromCompany(currentCompany.teams, stats.rangeOfDates),
      );
      Vue.set(stats.companies[currentCompanyIndex], 'isFormatted', true);
      return;
    }
    const currentTeam = currentCompany.teams.find(team => Number(team.id) === Number(ids.teamId));
    const currentTeamIndex = stats.companies[currentCompanyIndex].teams
      .findIndex(team => Number(team.id) === Number(ids.teamId));
    if (dataType === 'teams') {
      if (!currentTeam.data) {
        Vue.set(
          stats.companies[currentCompanyIndex],
          'teams',
          formatDataFromCompany(currentCompany.teams, stats.rangeOfDates),
        );
        Vue.set(stats.companies[currentCompanyIndex], 'isFormatted', true);
      }
      Vue.set(
        stats.companies[currentCompanyIndex].teams[currentTeamIndex],
        'users',
        formatUsers(currentTeam.users, stats.rangeOfDates),
      );
      Vue.set(stats.companies[currentCompanyIndex].teams[currentTeamIndex], 'isFormatted', true);
      return;
    }
    if (dataType === 'users') {
      const currentUser = currentTeam.users.find(user => Number(user.id) === Number(ids.userId));
      const currentUserIndex = stats.companies[currentCompanyIndex].teams[currentTeamIndex].users
        .findIndex(user => Number(user.id) === Number(ids.userId));
      Vue.set(
        stats.companies[currentCompanyIndex].teams[currentTeamIndex].users,
        currentUserIndex,
        formatCurrentUser(currentUser, stats.rangeOfDates),
      );
      Vue.set(
        stats.companies[currentCompanyIndex].teams[currentTeamIndex].users[currentUserIndex],
        'isFormatted',
        true,
      );
    }
  },
};

export default mutations;
